import { render, staticRenderFns } from "./Marriage.vue?vue&type=template&id=2dcc35f9"
import script from "./Marriage.vue?vue&type=script&lang=js"
export * from "./Marriage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports